import { render, staticRenderFns } from "./career-detail.vue?vue&type=template&id=5c8688a5&scoped=true&"
import script from "./career-detail.vue?vue&type=script&lang=js&"
export * from "./career-detail.vue?vue&type=script&lang=js&"
import style0 from "./career-detail.vue?vue&type=style&index=0&id=5c8688a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8688a5",
  null
  
)

export default component.exports